/* eslint-disable @typescript-eslint/naming-convention */
import { events } from '../../../proto/protobuf';
import { TelemetryClientId } from '../../config/types';
import { getTelemetryClientConfig } from '../../telemetryStore';

import { loadProtobuf } from './lazyExports';

type GetWebClientTypeMap = (
  WebClientType: typeof events.WebClientTypeV1
) => Record<TelemetryClientId, events.WebClientTypeV1>;
const getWebClientTypeMap: GetWebClientTypeMap = (WebClientType) => ({
  UNKNOWN: WebClientType.UNKNOWN,
  YAMMER_EMBED: WebClientType.YAMMER_EMBED,
  YAMMER_VIVA_CONNECTIONS: WebClientType.YAMMER_VIVA_CONNECTIONS,
  YAMMER_METAOS_OUTLOOK_PERSONAL_APP: WebClientType.YAMMER_METAOS_OUTLOOK_PERSONAL_APP,
  YAMMER_METAOS_OFFICE_PERSONAL_APP: WebClientType.YAMMER_METAOS_OFFICE_PERSONAL_APP,
  YAMMER_OUTLOOK: WebClientType.YAMMER_OUTLOOK,
  YAMMER_SHAREPOINT: WebClientType.YAMMER_SHAREPOINT,
  YAMMER_SHAREPOINT_SHARETO: WebClientType.YAMMER_SHAREPOINT_SHARETO,
  YAMMER_TEAMS: WebClientType.YAMMER_TEAMS,
  YAMMER_TEAMS_MEETING: WebClientType.YAMMER_TEAMS_MEETING,
  YAMMER_TEAMS_PERSONAL_APP: WebClientType.YAMMER_TEAMS_PERSONAL_APP,
  YAMMER_VIVAENGAGE_PERSONAL_APP: WebClientType.YAMMER_VIVAENGAGE_PERSONAL_APP,
  YAMMER_VIVAENGAGE_OUTLOOK_PERSONAL_APP: WebClientType.YAMMER_VIVAENGAGE_OUTLOOK_PERSONAL_APP,
  YAMMER_VIVAENGAGE_OFFICE_PERSONAL_APP: WebClientType.YAMMER_VIVAENGAGE_OFFICE_PERSONAL_APP,
  YAMMER_WEB: WebClientType.YAMMER_WEB,
});

export const getWebClientType = async () => {
  const { telemetryClientId } = getTelemetryClientConfig();
  const { events } = await loadProtobuf();

  return getWebClientTypeMap(events.WebClientTypeV1)[telemetryClientId];
};
